(function () {
  function start() {
    const sections = document.querySelectorAll(
      ".reviews-custom-shop, .shops-carousel, .container-swiper",
    );
    if (!sections.length) return;

    let observer;
    let script;
    let stylesheet;
    let stylesReady = false;
    let notified = false;

    function ready() {
      if (!stylesReady || typeof window.Swiper !== "function" || notified) return;
      notified = true;
      if (observer) observer.disconnect();
      document.dispatchEvent(new Event("t4s:swiper:ready"));
    }

    function load() {
      if (!stylesheet) {
        stylesheet = document.createElement("link");
        stylesheet.rel = "stylesheet";
        stylesheet.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        stylesheet.onload = function () {
          stylesReady = true;
          ready();
        };
        stylesheet.onerror = function () {
          stylesheet.remove();
          stylesheet = null;
        };
        document.head.appendChild(stylesheet);
      }

      if (typeof window.Swiper === "function") {
        ready();
        return;
      }
      if (script) return;

      script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      script.async = true;
      script.onload = function () {
        if (typeof window.Swiper === "function") ready();
        else script.onerror();
      };
      script.onerror = function () {
        script.remove();
        script = null;
      };
      document.head.appendChild(script);
    }

    if (window.Shopify?.designMode || !("IntersectionObserver" in window)) {
      load();
      return;
    }

    observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) load();
      },
      { rootMargin: "300px 0px" },
    );
    sections.forEach((section) => observer.observe(section));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
